// Centralized Sunny's bar info — used across the site
export const BAR = {
  name: "Sunny's Bar",
  address: {
    street: "902 Capitol St",
    cityState: "Houston, TX 77002",
    full: "902 Capitol St, Houston, TX 77002",
  },
  phone: {
    display: "(713) 224-3200",
    tel: "+17132243200",
  },
  // Day-by-day accurate hours
  hours: [
    { id: "mon", days: "Monday", time: "4:00 PM – 12:00 AM" },
    { id: "tue-fri", days: "Tuesday – Friday", time: "2:00 PM – 2:00 AM" },
    { id: "sat", days: "Saturday", time: "5:00 PM – 2:00 AM" },
    { id: "sun", days: "Sunday", time: "2:00 PM – 12:00 AM" },
  ],
  happyHour: "Tue – Fri · 2:00 – 7:00 PM",
  ageRestriction: "21+ only · Valid ID required",
  payments: "Cash & cards accepted",
  food: "Outside local food welcome",
  social: {
    instagram: "https://www.instagram.com/sunnysbar/",
    facebook: "https://www.facebook.com/sunnysbarhouston",
  },
};

// Direct Google Maps Place link via Google CID — opens native Maps app on mobile
export const MAPS_CID_URL = "https://maps.google.com/?cid=10799454632505922077";

// Standard "directions" deep link (preserves cross-platform behavior)
export const MAPS_DIRECTIONS_URL = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
  BAR.address.full,
)}`;

// Embed (no API key required) — pinned by full address
export const MAPS_EMBED_URL = `https://www.google.com/maps?q=${encodeURIComponent(
  BAR.address.full,
)}&z=16&output=embed`;

// Spotify — dark-themed embed (theme=0 = dark)
// Today's Top Hits (Spotify's flagship editorial playlist); swap when owner provides custom playlist
export const SPOTIFY_PLAYLIST_ID = "37i9dQZF1DXcBWIGoYBM5M";
export const SPOTIFY_EMBED_URL = `https://open.spotify.com/embed/playlist/${SPOTIFY_PLAYLIST_ID}?utm_source=generator&theme=0`;
